import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import IconHeader from "../../images/logo.png";
import "./style.scss";

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object({
    email: Yup.string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email address"
      )
      .required("Email is required")
  });

  const formik = useFormik({
    validateOnChange: true,
    validateOnBlur: false,
    initialValues: {
      email: ""
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);

      // Simulate forgot password request
      setTimeout(() => {
        toast.success("Password reset link sent to your email!", {
          position: toast.POSITION.TOP_RIGHT
        });

        setTimeout(() => {
          navigate("/");
        }, 2000);

        setLoading(false);
      }, 1000);
    }
  });

  return (
    <section className="dashboard credential-page">
      <Container fluid>
        <Row className="justify-content-md-center">
          <Col xl={5} lg={10} md={12} sm={12}>
            <Card className="px-5 pt-4 pb-5" style={{ borderRadius: "16px" }}>
              <figure className="text-center">
                <img src={IconHeader} alt="logo" width={250} />
                <h2>Forgot Password</h2>
                <p className="text-muted">
                  Enter your email address and we'll send you a link to reset your password.
                </p>
              </figure>
              <Form onSubmit={formik.handleSubmit} noValidate>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label className="mb-1">
                    Email Address<sup>*</sup>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="p-3"
                    isInvalid={formik.touched.email && !!formik.errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.email}
                  </Form.Control.Feedback>
                </Form.Group>

                <Button
                  variant="primary"
                  className="mt-2 border-0 text-white font-16 w-100 py-3 gilroy-semibold"
                  type="submit"
                  size="lg"
                  disabled={formik.isSubmitting || loading}
                >
                  {loading ? "Sending..." : "Send Reset Link"}
                </Button>

                <Button
                  variant="link"
                  className="mt-3 text-center w-100 text-primary"
                  onClick={() => navigate("/")}
                >
                  Back to Login
                </Button>
              </Form>
            </Card>
          </Col>
        </Row>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
        />
      </Container>
    </section>
  );
};

export default ForgotPassword;